<template>
  <div class="d-flex flex-row">
    <div
      class="flex-row-auto offcanvas-mobile w-300px w-xl-350px"
      id="kt_profile_aside"
    >
      <div class="card card-custom card-stretch">
        <div class="card-body pt-4">
          <div class="d-flex justify-content-end">
            <KTDropdown2></KTDropdown2>
          </div>
          <div class="d-flex align-items-center">
            <div
              class="symbol symbol-60 symbol-xxl-100 mr-5 align-self-start align-self-xxl-center"
            >
              <div class="symbol-label">
                <v-img
                src="/media/users/default.jpg"
                ></v-img>
              </div>
              <!-- <i class="symbol-badge bg-success"></i> -->
            </div>
            <div>
              <a
                class="font-weight-bolder font-size-h5 text-dark-75 text-hover-primary"
                >{{ getFullName }}</a
              >
              <!-- <div class="text-muted">Application Developer</div> -->
            </div>
          </div>
          <!--end::User-->
          <!--begin::Contact-->
          <div class="py-9">
            <div class="d-flex align-items-center justify-content-between mb-2">
              <span class="font-weight-bold mr-2">E-mel:</span>
              <a class="text-muted text-hover-primary">{{
                currentUser.email
              }}</a>
            </div>
            <div class="d-flex align-items-center justify-content-between mb-2">
              <span class="font-weight-bold mr-2">No. Telefon:</span>
              <span class="text-muted">{{
                currentUser.phone_num_display
              }}</span>
            </div>
          </div>
          <!--end::Contact-->
          <!--begin::Nav-->
          <div
            class="navi navi-bold navi-hover navi-active navi-link-rounded"
            role="tablist"
          >
            <div class="navi-item mb-2">
              <a
                class="navi-link py-4"
                @click="setActiveTab"
                style="cursor: pointer"
                data-tab="0"
                data-toggle="tab"
                role="tab"
                aria-selected="false"
              >
                <span class="navi-icon mr-2"> </span>
                <span class="navi-text font-size-lg">Maklumat Diri</span>
              </a>
            </div>
            <div class="navi-item mb-2">
              <a
                class="navi-link py-4"
                @click="setActiveTab"
                style="cursor: pointer"
                data-tab="1"
                data-toggle="tab"
                role="tab"
                aria-selected="false"
              >
                <span class="navi-icon mr-2"> </span>
                <span class="navi-text font-size-lg">Kata Laluan</span>
                <!-- <span class="navi-label">
                  <span
                    class="label label-light-danger label-rounded font-weight-bold"
                    >5</span
                  >
                </span> -->
              </a>
            </div>
          </div>
        </div>
      </div>
    </div>

    <!--begin::Content-->
    <div class="flex-row-fluid ml-lg-8">
      <b-tabs class="hide-tabs" v-model="tabIndex">
        <b-tab title="Maklumat Diri" active>
          <KTPersonalInformation></KTPersonalInformation>
        </b-tab>

        <b-tab title="Kata Laluan">
          <KTChangePassword
          :currentUser="currentUser"
          :currentUserRoles="currentUserRoles"
          ></KTChangePassword>
        </b-tab>
      </b-tabs>
    </div>
    <!--end::Content-->
  </div>
</template>

<script>
import { mapGetters } from "vuex";
import { SET_BREADCRUMB } from "@/core/services/store/breadcrumbs.module";
import { GET_USER } from "@/core/services/store/user.module";

import KTDropdown2 from "@/view/content/dropdown/Dropdown2";
import KTPersonalInformation from "@/view/pages/profile/profile-comp/PersonalInformation";
import KTChangePassword from "@/view/pages/profile/profile-comp/ChangePassword";

export default {
  name: "custom-page",
  components: {
    KTDropdown2,
    KTPersonalInformation,
    KTChangePassword,
  },
  data() {
    return {
      tabIndex: 0,
    };
  },
  mounted() {
    // const user_id = localStorage.getItem("uid");

    this.$store.dispatch(SET_BREADCRUMB, [{ title: "Profile" }]);
    this.$store.dispatch(GET_USER/* , { user_id } */);
  },
  methods: {
    /**
     * Set current active on click
     * @param event
     */
    setActiveTab(event) {
      let target = event.target;
      if (!event.target.classList.contains("navi-link")) {
        target = event.target.closest(".navi-link");
      }

      const tab = target.closest('[role="tablist"]');
      const links = tab.querySelectorAll(".navi-link");
      // remove active tab links
      for (let i = 0; i < links.length; i++) {
        links[i].classList.remove("active");
      }

      // set clicked tab index to bootstrap tab
      this.tabIndex = parseInt(target.getAttribute("data-tab"));

      // set current active tab
      target.classList.add("active");
    },
  },
  computed: {
    // ...mapGetters(["currentUserPersonalInfo"]),
    ...mapGetters(["currentUser", "currentUserRoles"]),

    getFullName() {
      return (
        this.currentUser.full_name
      );
    },
  },
};
</script>
